<template>
	<div>
		<!-- with blob -->
		<video controls v-if="blobUrl" class="xs-12" style="max-width: 100%;">
			<source :type="mimetype" :src="blobUrl" />
		</video>
		<j-spinner class="p8" v-else size="small" />
	</div>
</template>

<script>
import axios from "axios"
import JSpinner from "@/components/JSpinner"

export default {
	props: {
		filekey: String
	},

	components: {
		JSpinner
	},

	data() {
		return {
			blobUrl: null,
			mimetype: "video/mp4"
		}
	},

	methods: {
		async getVideoPreview() {
			// Auth
			const headers = {
				Authorization: `Bearer ${window.TK}`
			}
			const res = await axios({
				url:
					"https://api.asia.covergo.com/api/v1/files/" +
					encodeURIComponent(this.filekey),
				headers,
				responseType: "blob"
			})
			// Create url
			if (res?.data) {
				this.blobUrl = URL.createObjectURL(res.data)
			}
		}
	},

	created() {
		this.getVideoPreview()
	}
}
</script>
